<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query['command.id']" placeholder="placeholder.commandId" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-select v-model="query['commandStatus']" :options="commandStatus" placeholder="placeholder.commandStatus" @change="refresh"/>
        <vxe-input v-model="query['wave']" placeholder="placeholder.wave" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['order.no']" placeholder="placeholder.orderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-select v-model="query['owner.id']" :options="owners" placeholder="placeholder.owner" @change="refresh"/>
        <vxe-input v-model="query['customer.name']" placeholder="placeholder.customerName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['pickingOrder.no']" placeholder="placeholder.pickingOrderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['container.no']" placeholder="placeholder.containerNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['loadingOrder.no']" placeholder="placeholder.loadingOrderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.no']" placeholder="placeholder.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.barcode']" placeholder="placeholder.itemBarcode" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['storageRoom.name']" placeholder="placeholder.storageRoom" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['barcode.no']" placeholder="business.label.shipmentBarcode" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-select v-model="query['packType']" :options="packTypes" placeholder="placeholder.packType" @change="refresh"/>
        <vxe-select v-model="query['legalAttribute.ids']" :options="legalAttributes" multiple placeholder="placeholder.legalAttribute" @change="refresh"/>
        <vxe-select v-model="query['storageRequest.ids']" :options="storageRequests" multiple placeholder="placeholder.storageRequest" @change="refresh"/>
        <vxe-select v-model="query['dosageForm.ids']" :options="dosageForms" multiple placeholder="placeholder.dosageForm" @change="refresh"/>
        <vxe-input v-model="query['location.no']" placeholder="placeholder.location" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['exchangePosition.no']" placeholder="placeholder.exchangePosition" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['seedingPosition.no']" placeholder="placeholder.seedingPosition" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['packingPosition.no']" placeholder="placeholder.packingPosition" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['stagingPosition.no']" placeholder="placeholder.stagingPosition" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-select v-model="query['visualized']" :options="options" placeholder="placeholder.visualized" @change="refresh"/>
        <vxe-select v-model="query['stagingCompleted']" :options="options" placeholder="placeholder.stagingCompleted" @change="refresh"/>
        <vxe-select v-model="query['reviewed']" :options="options" placeholder="placeholder.reviewed" @change="refresh"/>
        <vxe-date-range-picker v-model="query.range" linked-panels placeholder="business.label.addTime" type="date" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.expConfirm" icon="vxe-icon-upload" status="info" @click="exp"/>
      </template>
      <vxe-table ref="table" :data="data" :export-config="{}" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="command.addTime" sortable title="business.label.addTime" width="170"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:commandStatus}" field="command.commandStatus" sortable title="business.label.commandStatus" width="100"/>
        <vxe-column field="order.no" sortable title="business.label.orderNo" width="120"/>
        <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
        <vxe-column field="dispatch.wave" sortable title="business.label.wave" width="100"/>
        <vxe-column field="barcode.no" sortable title="business.label.shipmentBarcode" width="100"/>
        <vxe-column field="owner.no" title="business.label.ownerNo" width="80"/>
        <vxe-column field="owner.name" title="business.label.ownerName" width="120"/>
        <vxe-column field="customer.no" title="business.label.customerNo" width="100"/>
        <vxe-column field="customer.name" title="business.label.customerName" width="120"/>
        <vxe-column field="logicalStore.name" title="business.label.logicalStore" width="90"/>
        <vxe-column field="carrier.name" title="business.label.carrierName" width="120"/>
        <vxe-column field="carrier.expressCode" title="business.label.expressCode" width="120"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName" width="120"/>
        <vxe-column field="pack.specification" title="business.label.specification" width="120"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="50"/>
        <vxe-column field="pack.innerFactor" title="business.label.innerFactor" width="60"/>
        <vxe-column field="lot.no" title="business.label.lotNo" width="150"/>
        <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
        <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
        <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150"/>
        <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150"/>
        <vxe-column field="location.no" title="business.label.locationNo" width="150"/>
        <vxe-column field="zone.no" title="business.label.zoneNo" width="150"/>
        <vxe-column field="storageRoom.name" title="business.label.storageRoom" width="150"/>
        <vxe-column field="checkoutLocation.no" title="business.label.checkoutLocation" width="150"/>
        <vxe-column field="checkoutContainer.no" title="business.label.checkoutContainer" width="150"/>
        <vxe-column field="container.no" title="business.label.sourceContainer" width="150"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:pickingModes}" field="command.pickingMode" title="business.label.pickingMode" width="100"/>
        <vxe-column field="command.plannedQuantity" title="business.label.plannedQuantity" width="150"/>
        <vxe-column field="command.actualQuantity" title="business.label.actualQuantity" width="150"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:appendageSigns}" field="command.appendageSign" title="business.label.appendageSign" width="150"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:packTypes}" field="command.packType" title="business.label.packType" width="120"/>
        <vxe-column field="pickingOrder.no" title="business.label.pickingOrderNo" width="150"/>
        <vxe-column field="picking.operator" title="business.label.picker" width="100"/>
        <vxe-column field="picking.startTime" sortable title="business.label.pickingStartTime" width="170"/>
        <vxe-column field="picking.finishTime" sortable title="business.label.pickingFinishTime" width="170"/>
        <vxe-column field="exchangePosition.no" title="business.label.exchangePosition" width="150"/>
        <vxe-column field="command.exchangingPositionAllocatedTime" sortable title="business.label.exchangingPositionAllocatedTime" width="170"/>
        <vxe-column field="exchangeContainer.no" title="business.label.exchangeContainer" width="150"/>
        <vxe-column field="exchange.exchanger" title="business.label.exchanger" width="100"/>
        <vxe-column field="exchange.exchangeTime" sortable title="business.label.exchangeTime" width="170"/>
        <vxe-column field="seedingPosition.no" title="business.label.seedingPosition" width="150"/>
        <vxe-column field="command.seedingPositionAllocatedTime" sortable title="business.label.seedingPositionAllocatedTime" width="170"/>
        <vxe-column field="seedingContainer.no" title="business.label.seedingContainer" width="150"/>
        <vxe-column field="seeding.operator" title="business.label.seeder" width="100"/>
        <vxe-column field="seeding.startTime" sortable title="business.label.seedingStartTime" width="170"/>
        <vxe-column field="command.visualReviewedTime" sortable title="business.label.visualReviewedTime" width="170"/>
        <vxe-column field="seeding.finishTime" sortable title="business.label.seedingFinishTime" width="170"/>
        <vxe-column field="packingPosition.no" title="business.label.packingPosition" width="150"/>
        <vxe-column field="command.packingPositionAllocatedTime" sortable title="business.label.packingPositionAllocatedTime" width="170"/>
        <vxe-column field="packing.operator" title="business.label.packer" width="100"/>
        <vxe-column field="packing.startTime" sortable title="business.label.packingStartTime" width="170"/>
        <vxe-column field="packing.finishTime" sortable title="business.label.packingFinishTime" width="170"/>
        <vxe-column field="stagingRegion.no" sortable title="business.label.stagingRegion" width="150"/>
        <vxe-column field="stagingPosition.no" title="business.label.stagingPosition" width="150"/>
        <vxe-column field="conveyor.no" title="business.label.conveyor" width="150"/>
        <vxe-column field="review.operator" title="business.label.stagingReviewer" width="100"/>
        <vxe-column field="review.startTime" sortable title="business.label.reviewStartTime" width="170"/>
        <vxe-column field="review.finishTime" sortable title="business.label.reviewFinishTime" width="170"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.activated" title="business.label.activated" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.supervised" title="business.label.supervised" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.scattered" title="business.label.scattered" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.visualized" title="business.label.visualized" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.autoSeeding" title="business.label.autoSeeding" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.autoPacking" title="business.label.autoPacking" width="60"/>
        <vxe-column field="command.id" title="business.label.commandId" width="180"/>
        <vxe-column field="command.commandGroup" title="business.label.commandGroup" width="180"/>
        <vxe-column field="command.task" title="business.label.taskId" width="180"/>
        <vxe-column field="pickingOrder.taskGroup" title="business.label.taskGroup" width="180"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import moment from 'moment/moment'
import { getDictionaries, getEnums, getOptions } from '@/utils/util'

export default {
  data() {
    return {
      loading: false,
      data: [],
      query: {
        'order.no': '',
        'command.id': '',
        packType: undefined,
        commandStatus: undefined,
        'item.no': '',
        'item.barcode': '',
        'container.no': '',
        'pickingOrder.no': '',
        'storageRoom.name': '',
        wave: '',
        'barcode.no': '',
        'owner.id': undefined,
        'customer.name': '',
        'location.no': '',
        'seedingPosition.no': '',
        'exchangePosition.no': '',
        'packingPosition.no': '',
        'stagingPosition.no': '',
        'loadingOrder.no': '',
        visualized: undefined,
        stagingCompleted: undefined,
        reviewed: undefined,
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      },
      owners: [],
      packTypes: [],
      commandStatus: [],
      pickingModes: [],
      appendageSigns: [],
      legalAttributes: [],
      storageRequests: [],
      dosageForms: [],
      options: [
        { label: this.$t('business.label.true'), value: true },
        { label: this.$t('business.label.false'), value: false }
      ],
      page: 1,
      size: 20,
      contentSize: 0
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
      return getEnums('CommandStatus')
    }).then(result => {
      this.commandStatus = result
      return getEnums('PackType')
    }).then(result => {
      this.packTypes = result
      return getEnums('PickingMode')
    }).then(result => {
      this.pickingModes = result
      return getEnums('AppendageSign')
    }).then(result => {
      this.appendageSigns = result
      return getDictionaries('LEGAL_ATTR')
    }).then(result => {
      this.legalAttributes = result
      return getDictionaries('STORAGE_REQUEST')
    }).then(result => {
      this.storageRequests = result
      return getDictionaries('DOSAGE_FORM')
    }).then(result => {
      this.dosageForms = result
    })
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = Object.assign({}, this.query)
      if (args.range.length > 0) {
        args['commandDateFilter'] = { start: args.range[0], end: args.range[1] }
      } else {
        args['commandDateFilter'] = null
      }
      findAll('shipmentCommandFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = {
        'order.no': '',
        'command.id': '',
        packType: undefined,
        commandStatus: undefined,
        'item.no': '',
        'item.barcode': '',
        'container.no': '',
        'pickingOrder.no': '',
        'storageRoom.name': '',
        wave: '',
        'barcode.no': '',
        'owner.id': undefined,
        'customer.name': '',
        'location.no': '',
        'seedingPosition.no': '',
        'exchangePosition.no': '',
        'packingPosition.no': '',
        'stagingPosition.no': '',
        'loadingOrder.no': '',
        visualized: undefined,
        stagingCompleted: undefined,
        reviewed: undefined,
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      }
      this.refresh()
    },
    exp() {
      this.$refs.table.openExport()
    }
  }
}
</script>